export default __webpack_public_path__ + "static/media/november.9d1bb9e8.jpg";